<template>
  <a :class="{
    'text-decoration': true,
    'link-blue': variant === 'terms'
  }">
    <slot></slot>
  </a>
</template>

<style scoped lang="css">
a.text-decoration {
  display: inline-block;
  text-decoration: underline;
}
</style>

<script>
export default {
  name: "Link",
  props: {
    // variant: [ default, terms ]
    variant: {
      type: String,
      default: "",
    },
  },
};
</script>
